module.exports = __webpack_public_path__ + "static/media/purpleTheme-girl.aa07ac65.svg";